const Style = {
    base: 'relative clear-both space-y-1.5 border-0 p-0 last:mb-0',
    error: 'rounded-md border border-error p-3',
    errorMessage: 'mb-0',
};

export default Style;
